import { useFeatureFlag } from "@imaginelearning/shared-components/useFeatureFlag";
import React, { Suspense } from "react";
import { unloadDoolittle } from "components/assignments/course-map-components/utils";
import AppWindow from "../../helpers/app-window";
import "./project-link-player.scss";
import { UxLoading } from "@imaginelearning/mps-ux-component-library";

const appWindow = AppWindow() as any;
export interface ILinkPlayerProps {
  mode?: string;
  isPreview?: boolean;
  pathId: string;
  pathVersion: number;
  studentId: string;
  attemptId: string;
  ctkEnvUrl?: string;
  ctkEnvId?: number;
  hierarchyId?: string;
  calculatorType?: string;
  onLinkPlayerClose?: (reasonCode: string) => void;
  onLinkPlayerError?: (errorMessage: string) => void;
  onPlayerReady?: () => void;
}

const LinkPlayer = React.lazy(() =>
  import("asmthostlinkplayer/LinkPlayer").catch((err) => {
    console.log("ERROR", err);
    return { default: () => <div>ERROR</div> };
  })
);

const defaultOnCloseLinkPlayer = async (reasonCode: string) => {
  // Redirect to previous page
  window.history.back();
};

function ProjectLinkPlayer(props: ILinkPlayerProps) {
  const {
    mode,
    isPreview,
    hierarchyId,
    pathId,
    pathVersion,
    studentId,
    attemptId,
    ctkEnvId,
    ctkEnvUrl,
    calculatorType,
    onLinkPlayerClose,
    onLinkPlayerError,
    onPlayerReady
  } = props;

  // Manage proxies for Local Development
  const envOverrides =
    window.location.hostname === "localhost"
      ? {
          LINK_PLAYER_API_URL: "/fixedform-api",
          CONTENT_TOOLKIT_GATEWAY_URL: "/content-toolkit/api"
        }
      : {};

  unloadDoolittle();

  const { getFlagValue } = useFeatureFlag();
  const onDemandTutoringEnabled = getFlagValue("enableOnDemandTutoring") === "on";

  return (
    <div data-testid="link-player" className="mps-link-player">
      <Suspense fallback={<UxLoading text="loading player" />}>
        <LinkPlayer
          linkPlayerProps={{
            mode: mode || "TAKE",
            isPreview: isPreview || false,
            hierarchyId,
            pathId,
            pathVersion,
            studentId,
            attemptId,
            calculatorType,
            onDemandTutoringEnabled,
            onPlayerReady,
            setError: (errorMessage: string) => {
              console.error("Link Player Error: ", errorMessage || "Unknown error");
              if (onLinkPlayerError) {
                onLinkPlayerError(errorMessage);
              }
            },
            onClose: (reasonCode: string) =>
              onLinkPlayerClose ? onLinkPlayerClose(reasonCode) : defaultOnCloseLinkPlayer(reasonCode),
            // externalTokenKey takes your session storage key for token, default: "access_token"
            externalTokenKey: "imlpToken",
            ctkEnvUrl: ctkEnvUrl || appWindow.STUDENT_ENV.REACT_APP_FIXEDFORM_PLAYER_CTK_ENV_URL,
            ctkEnvId: ctkEnvId || appWindow.STUDENT_ENV.REACT_APP_FIXEDFORM_PLAYER_CTK_ENV_ID
          }}
          playerBaseUrl={appWindow.STUDENT_ENV.REACT_LINK_PLAYER_URL}
          // Uncomment For local development only
          envOverrides={envOverrides}
        />
      </Suspense>
    </div>
  );
}

export default ProjectLinkPlayer;
